<!-- @format -->

@if (courseUnit(); as courseUnit) {
  <sis-study-box
    [id]="courseUnit.id"
    [name]="courseUnit.name"
    [code]="courseUnit.code"
    [credits]="courseUnit.credits"
    [level]="headingLevel()"
    [attainedCredits]="attainment()?.credits"
    [gradeId]="attainment()?.gradeId"
    [gradeScaleId]="attainment()?.gradeScaleId"
    (nameClickAction)="openCourseUnitInfoModal()">
    @if (plannedPeriods(); as plannedPeriods) {
      <ng-container study-box="notifications">
        <app-timeline-multi-period-timing-notification-box [plannedPeriods]="plannedPeriods" [currentPeriod]="currentPeriod()" />
      </ng-container>
    }
  </sis-study-box>
}
